import React, {Component, createRef} from 'react';
import { connect } from 'react-redux';

import classes from './PatternLibrary.module.css';
import Modal from "../../components/UI/Modal/Modal";
import PatternSearchBar from "../../components/PatternSearchBar/PatternSearchBar";
import * as actionTypes from '../../store/actions/actionTypes';
import PatternList from '../../components/PatternList/PatternList';
import PatternDetails from '../../components/PatternDetails/PatternDetails';
import NewPattern from '../../components/NewPattern/NewPattern';
import apiUrl from '../../shared/config';
import history from '../../history';
import PresetModal from "../../components/UI/Modal/PresetModal/PresetModal";
import axios from "axios";
import MergeScreen from "../../components/Merging/MergeScreen";
import {cancelEditLock, LockType} from "../../utils/lockUtils";

class PatternLibrary extends Component {
    constructor(props) {
        super(props);
        this.newPatternModal = createRef();
        this.state = {
            newPatternModalText: {
                title: "",
                body: "",
                onClose: () => {},
            },
            mounted: false,
            authors: [],
            keywords: [],
            conditions: [],
            constraints: [],
            consequences: [],
            groups: [],
            games: [],
            patternCounts : {
                count: 0,
                invisibleCount: 0,
            },
        };
    }

    componentDidMount() {
        if (this.props.match.params.patternId !== undefined &&
            this.props.match.params.patternId !== null &&
            this.props.selectedPattern.id !== this.props.match.params.patternId
        ) {
            // When the Pattern Library mounts, if there is a pattern ID in the URL
            // that is not the same as the selected pattern's ID, select the pattern
            // indicated by the URL
            this.props.onSelectPattern(this.props.match.params.patternId);
        }
        if (this.state.authors.length === 0) {
            axios.get(apiUrl + 'Users/getUsers')
                .then(response => {
                    this.setState({ authors: response.data});
                });
        }
        if (this.state.keywords.length === 0) {
            axios.get(apiUrl + 'Keywords/getKeywords')
                .then(response => {
                    this.setState({ keywords: response.data});
                });
        }
        if (this.state.conditions.length === 0) {
            axios.get(apiUrl + 'PatternConditions/getPatternConditions')
                .then(response => {
                    this.setState({ conditions: response.data});
                });
        }
        if (this.state.constraints.length === 0) {
            axios.get(apiUrl + 'PatternConstraints/getPatternConstraints')
                .then(response => {
                    this.setState({ constraints: response.data});
                });
        }
        if (this.state.consequences.length === 0) {
            axios.get(apiUrl + 'PatternConsequences/getPatternConsequences')
                .then(response => {
                    this.setState({ consequences: response.data});
                });
        }
        if (this.state.groups.length === 0) {
            axios.get(apiUrl + 'Groups/getGroups')
                .then(response => {
                    this.setState({ groups: response.data});
                });
        }
        if (this.state.games.length === 0) {
            axios.get(apiUrl + 'Games/getGames')
                .then(response => {
                    this.setState({ games: response.data});
                });
        }

        this.setState({
            newPatternModalText: {
                title: "",
                body: "",
                onClose: () => {},
            }
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // If the pattern is selected when mounted, there are no manual updates to the browser history, as this is
        // handled automatically. Setting mounted to 'true' on the first update prevents the manual calls from happening
        if (!this.state.mounted) {
            this.setState({mounted: true})
        }

        if (this.state.mounted && prevProps.selectedPattern
            && prevProps.selectedPattern.id !== this.props.selectedPattern.id) {
            if (this.props.selectedPattern.id !== undefined && this.props.selectedPattern.id !== null) {
                // In the case that there's been a change to the selected pattern and the selected pattern is
                // not null or undefined, add the new pattern's link to the browser history
                if (history.location.pathname !== '/PatternLibraryApp/PatternLibrary/' + this.props.selectedPattern.id) {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log("push pl a", history.location.pathname, '/PatternLibraryApp/PatternLibrary/' + this.props.selectedPattern.id)
                    history.push('/PatternLibraryApp/PatternLibrary/' + this.props.selectedPattern.id);
                }
            } else {
                // In the case that there's been a change to the selected pattern and the selected pattern is null
                // or undefined, add the default link to the Pattern Library to the browser's history
                if (history.location.pathname !== '/PatternLibraryApp/PatternLibrary/') {
                    // This if-statement prevents the same URL from being pushed to the history multiple times in a row
                    // console.log("push pl b", history.location.pathname, '/PatternLibraryApp/PatternLibrary/')
                    history.push('/PatternLibraryApp/PatternLibrary/')
                }
            }
        } else if (this.state.mounted && this.props.selectedPattern.id && !this.props.match.params.patternId) {
            // In the case that there is no change in the selected pattern, but there's a selected pattern and no
            // pattern id in the URL, replace the link in history with one that goes directly to the selected pattern
            // console.log("push pl r", history.location.pathname, '/PatternLibraryApp/PatternLibrary/' + this.props.selectedPattern.id)
            history.replace('/PatternLibraryApp/PatternLibrary/' + this.props.selectedPattern.id);
        }

    }

    updatePatternCounts = (visible, invisible) => {
        let newCount = {...this.state.patternCounts}
        if (visible !== null) {
            newCount.count = visible;
        }
        if (invisible !== null) {
            newCount.invisibleCount = invisible
        }
        this.setState({patternCounts: newCount})
    }

    patternSelectedHandler = (id) => {
        //console.log('Pattern Select Handler', id);
        this.props.onSelectPattern(id);
    };

    patternAddHandler = () => {
        this.props.onAddPattern();
    };

    patternVoteHandler = () => {
        this.props.onVotePattern();
    };

    patternCloseHandler = () => {
        this.props.onClosePatternDetails();
    };

    listReloadedHandler = () => {
        this.props.onListReloaded();
    };

    updateKeywordsFilterHandler = (keyword_ids) => {
        //console.log('Keywords Filter: ', keyword_ids);
        if(keyword_ids[0] === undefined) {
            keyword_ids = [];
        }
        this.props.onUpdateKeywordsFilter(keyword_ids);
    };

    updateConditionsFilterHandler = (condition_ids) => {
        if(condition_ids[0] === undefined) {
            condition_ids = [];
        }
        this.props.onUpdateConditionsFilter(condition_ids);
    };

    updateConstraintsFilterHandler = (constraint_ids) => {
        if(constraint_ids[0] === undefined) {
            constraint_ids = [];
        }
        this.props.onUpdateConstraintsFilter(constraint_ids);
    };

    updateConsequencesFilterHandler = (consequence_ids) => {
        if(consequence_ids[0] === undefined) {
            consequence_ids = [];
        }
        this.props.onUpdateConsequencesFilter(consequence_ids);
    };

    reduceKeywordsArrayToFilter = (keywords_array) => {
        let keywords_filter = [];
        if (keywords_array !== null) {
            keywords_filter = keywords_array.map((keyword_object) => { return keyword_object.value});
        }
        //console.log('KEYWORDS FILTER', keywords_filter);
        this.updateKeywordsFilterHandler(keywords_filter);
    };

    reduceConditionsArrayToFilter = (conditions_array) => {
        let conditions_filter = [];
        if (conditions_array !== null) {
            conditions_filter = conditions_array.map((condition_object) => { return condition_object.value});
        }
        this.updateConditionsFilterHandler(conditions_filter);
    }

    reduceConstraintsArrayToFilter = (constraints_array) => {
        let constraints_filter = [];
        if (constraints_array !== null) {
            constraints_filter = constraints_array.map((constraint_object) => { return constraint_object.value});
        }
        this.updateConstraintsFilterHandler(constraints_filter);
    }

    reduceConsequencesArrayToFilter = (consequences_array) => {
        let consequences_filter = [];
        if (consequences_array !== null) {
            consequences_filter = consequences_array.map((consequence_object) => { return consequence_object.value});
        }
        this.updateConsequencesFilterHandler(consequences_filter);
    }

    authorsFilterHandler = (new_value) => {
        let authors_array = [];
        if (new_value !== null) {
            authors_array = new_value.map((author) => { return author.value });
        }

        this.props.onUpdateAuthorsFilter(authors_array);
    };

    groupsFilterHandler = (new_value) => {
        let groups_array = [];
        if (new_value !== null) {
            groups_array = new_value.map((group) => { return group.value });
        }

        this.props.onUpdateGroupsFilter(groups_array);
    };

    patternNameFilterHandler = (new_value) => {
        this.props.onUpdatePatternNameFilter(new_value);
    };

    descriptionFilterHandler = (new_value) => {
        this.props.onUpdateDescriptionFilter(new_value);
    }

    exampleGamesFilterHandler = (new_value) => {
        this.props.onUpdateExampleGamesFilter(new_value);
    }

    designProblemFilterHandler = (new_value) => {
        this.props.onUpdateDesignProblemFilter(new_value);
    }

    updatePageHandler = (new_offset) => {
        this.props.onUpdatePagination(new_offset);
    };

    updateOrderByHandler = (new_order) => {
        this.props.onUpdateOrderBy(new_order);
    };

    newPatternOpenHandler = (id) => {
        this.props.onNewPatternOpen(id);
    };

    newPatternCloseHandler = (reassignId = true) => {
        const id = this.props.selectedPattern.id
        if (id) {
            cancelEditLock(this.props.token, id, LockType.PATTERN)
                .then((response) => console.log("Lock", response))
                .catch(() => console.log("Failed to cancel lock"))
        }
        this.props.onNewPatternClosed();
        if (reassignId) {
            this.props.onSelectPattern(id)
        }
    };

    toggleSearchHandler = () => {
        this.props.onToggleSearch();
    };

    gameSelectedHandler = (id) => {
        this.props.onSelectGame(id);
    };

    newPatternModalChangeTextHandler = (textObject) => {
        this.setState({newPatternModalText: {...this.state.newPatternModalText, ...textObject}});
    };

    newPatternModalOnCloseSet = (func) => {
        this.setState({newPatternModalText: {...this.state.newPatternModalText, onClose: func}});
    }

    patternSearchBar = (header_text) => (
        <PatternSearchBar
            userId={this.props.userId}
            headerText={header_text}
            authorsFilter={this.props.authors_filter}
            updateAuthorsFilter={this.authorsFilterHandler}
            groupsFilter={this.props.groups_filter}
            updateGroupsFilter={this.groupsFilterHandler}
            keywordsFilter={this.props.keywords_filter}
            updateKeywordsFilter={this.reduceKeywordsArrayToFilter}
            conditionsFilter={this.props.conditions_filter}
            updateConditionsFilter={this.reduceConditionsArrayToFilter}
            constraintsFilter={this.props.constraints_filter}
            updateConstraintsFilter={this.reduceConstraintsArrayToFilter}
            consequencesFilter={this.props.consequences_filter}
            updateConsequencesFilter={this.reduceConsequencesArrayToFilter}
            patternNameFilter={this.props.pattern_name_filter}
            updatePatternNameFilter={this.patternNameFilterHandler}
            descriptionFilter={this.props.description_filter}
            updateDescriptionFilter={this.descriptionFilterHandler}
            exampleGamesFilter={this.props.example_games_filter}
            updateExampleGamesFilter={this.exampleGamesFilterHandler}
            designProblemFilter={this.props.design_problem_filter}
            updateDesignProblemFilter={this.designProblemFilterHandler}
            orderBy={this.props.order_by}
            updateOrderBy={this.updateOrderByHandler}
            updatePage={this.updatePageHandler}
            closePatternDetails={this.patternCloseHandler}
            toggleSearch={this.toggleSearchHandler}
            authorsArr={this.state.authors}
            gamesArr={this.state.games}
            keywordsArr={this.state.keywords}
            conditionsArr={this.state.conditions}
            constraintsArr={this.state.constraints}
            consequencesArr={this.state.consequences}
            groupsArr={this.state.groups}
            patternsCount={this.state.patternCounts}
        />
    );

    welcomeModal = (modal_text) => (<section className={classes.Notice}  style={{width: "100%"}}>
        <div className={"card "+ classes.SearchFilterActiveNotice} style={{width: "80%", textAlign: "center"}} onClick={this.toggleSearchHandler}>
            <h4 className={"card-header "+classes.NoticeHeader}>{modal_text}</h4>
        </div>
    </section>);

    isActivePatternSearch = () => ((this.props.groups_filter !== null && this.props.groups_filter.length > 0) ||
        (this.props.authors_filter !== null && this.props.authors_filter.length > 0) ||
        (this.props.keywords_filter !== null && this.props.keywords_filter.length > 0) ||
        (this.props.conditions_filter !== null && this.props.conditions_filter.length > 0) ||
        (this.props.constraints_filter !== null && this.props.constraints_filter.length > 0) ||
        (this.props.consequences_filter !== null && this.props.consequences_filter.length > 0) ||
        (this.props.pattern_name_filter !== null && this.props.pattern_name_filter.length > 0) ||
        (this.props.description_filter !== null && this.props.description_filter.length > 0) ||
        (this.props.design_problem_filter !== null && this.props.design_problem_filter.length > 0) ||
        (this.props.example_games_filter !== null && this.props.example_games_filter.length > 0))

    getSearchText = () => {
        let str = '';

        const endText = (arr, label) => {
            let buildstr = label + (arr.length > 1 ? 's: ' : ': ');
            arr.forEach((item, index) => {
                if (index === 0) {
                    buildstr += item;
                } else {
                    buildstr += ", " + item;
                }
            });
            return buildstr + "_";
        }

        if (this.props.authors_filter !== null && this.props.authors_filter.length > 0) {
            str += endText(this.props.authors_filter.map(a => this.state.authors.find(u => +u.user_id === +a) ? this.state.authors.find(u => +u.user_id === +a).display_name : "Loading..."), "Author");
        }

        if (this.props.groups_filter !== null && this.props.groups_filter.length > 0) {
            str += endText(this.props.groups_filter.map(a => this.state.groups.find(g => +g.group_id === +a) ? this.state.groups.find(g => +g.group_id === +a).group_name : "Loading..."), "Group");
        }

        if (this.props.keywords_filter !== null && this.props.keywords_filter.length > 0) {
            str += endText(this.props.keywords_filter.map(a => this.state.keywords.find(k => +k.keyword_id === +a) ? this.state.keywords.find(k => +k.keyword_id === +a).keyword : "Loading..."), "Keyword");
        }

        if (this.props.conditions_filter !== null && this.props.conditions_filter.length > 0) {
            str += endText(this.props.conditions_filter.map(a => this.state.conditions.find(k => +k.condition_id === +a) ? this.state.conditions.find(k => +k.condition_id === +a).condition_title : "Loading..."), "Condition");
        }

        if (this.props.constraints_filter !== null && this.props.constraints_filter.length > 0) {
            str += endText(this.props.constraints_filter.map(a => this.state.constraints.find(k => +k.constraint_id === +a) ? this.state.constraints.find(k => +k.constraint_id === +a).constraint_title : "Loading..."), "Constraint");
        }

        if (this.props.consequences_filter !== null && this.props.consequences_filter.length > 0) {
            str += endText(this.props.consequences_filter.map(a => this.state.consequences.find(k => +k.consequence_id === +a) ? this.state.consequences.find(k => +k.consequence_id === +a).consequence_title : "Loading..."), "Consequence");
        }

        if (this.props.example_games_filter !== null && this.props.example_games_filter.length > 0) {
            str += endText(this.props.example_games_filter.map(a => this.state.games.find(g => +g.game_id === +a) ? this.state.games.find(g => +g.game_id === +a).game_name : "Loading..."), "Example Game");
        }

        if (this.props.pattern_name_filter !== null && this.props.pattern_name_filter.length > 0) {
            str += "Pattern Name_"
        }

        if (this.props.design_problem_filter !== null && this.props.design_problem_filter.length > 0) {
            str += "Design Problem_"
        }

        if (this.props.description_filter !== null && this.props.description_filter.length > 0) {
            str += "Description_"
        }

        if (str.length !== 0) {
            str = str.slice(0, -1)
            str = str.replaceAll("_", "｜")
        }

        return <span className={'truncate'} style={{color: "gray", display: "inline-block", padding: 2, maxWidth: "calc(100% - 200px)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }}>{str}</span>;
    }



    render () {
        return (
            <div>
                <header><h1 className={classes.PageTitle}>PATTERN LIBRARY</h1></header>
                {!this.props.search_panel_active && !this.props.merge_modal_show
                    ?
                    (this.isActivePatternSearch()
                        ? this.welcomeModal(<div style={{width: "100%"}}><span style={{display: "inline-block", maxWidth: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            padding: "2px 5px 2px 2px"
                        }}>{"Pattern Search - "}</span>{this.getSearchText()}</div>)
                        : this.welcomeModal(<div style={{width: "100%"}}><span style={{display: "inline-block", maxWidth: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            padding: "2px",
                        }}>Pattern Search</span></div>))
                    : ""}
                {!this.props.merge_modal_show && <section className={classes.PatternSearchBar}>
                    {this.props.search_panel_active
                        ? (this.isActivePatternSearch()
                            ? this.patternSearchBar(<div style={{width: '100%'}}><span style={{display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                padding: "2px 5px 2px 2px"
                            }}>{"Pattern Search - "}</span>{this.getSearchText()}</div>)
                            : this.patternSearchBar(<div style={{width: "100%"}}><span style={{
                                display: "inline-block", maxWidth: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                padding: "2px",
                            }}>Pattern Search</span></div>))
                        : ""}
                </section>}
                {!this.props.merge_modal_show && <section className={classes.Patterns}>
                    <PatternList
                        patternSelected={this.patternSelectedHandler}
                        selectedPatternId={this.props.selectedPattern.id}
                        reloadList={this.props.reloadList}
                        listReloaded={this.listReloadedHandler}
                        newPattern={this.newPatternOpenHandler}
                        closePatternDetails={this.patternCloseHandler}
                        authorsFilter={this.props.authors_filter}
                        groupsFilter={this.props.groups_filter}
                        keywordsFilter={this.props.keywords_filter}
                        conditionsFilter={this.props.conditions_filter}
                        constraintsFilter={this.props.constraints_filter}
                        consequencesFilter={this.props.consequences_filter}
                        patternNameFilter={this.props.pattern_name_filter}
                        descriptionFilter={this.props.description_filter}
                        exampleGamesFilter={this.props.example_games_filter}
                        designProblemFilter={this.props.design_problem_filter}
                        order_by={this.props.order_by}
                        patternList={this.props.patternList}
                        updatePage={this.updatePageHandler}
                        isAuthenticated={this.props.isAuthenticated}
                        token={this.props.token}
                        userId={this.props.userId}
                        updateCount={this.updatePatternCounts}
                    />
                </section>}
                <section id="pattern-details">
                    {!this.props.merge_modal_show &&
                        <PatternDetails
                            id={this.props.selectedPattern.id}
                            urlId={this.props.match.params.patternId}
                            patternDetailsOpen={this.props.patternDetailsOpen}
                            closePatternDetails={this.patternCloseHandler}
                            patternSelected={this.patternSelectedHandler}
                            listReloaded={this.listReloadedHandler}
                            votePattern={this.patternVoteHandler}
                            updateKeywordsFilter={this.updateKeywordsFilterHandler}
                            updateConditionsFilter={this.updateConditionsFilterHandler}
                            updateConstraintsFilter={this.updateConstraintsFilterHandler}
                            updateConsequencesFilter={this.updateConsequencesFilterHandler}
                            updatePage={this.updatePageHandler}
                            editPattern={this.newPatternOpenHandler}
                            isAuthenticated={this.props.isAuthenticated}
                            userId={this.props.userId}
                            authenticationLevel={this.props.authenticationLevel}
                            gameSelected={this.gameSelectedHandler}
                            token={this.props.token}
                            permissions={this.props.permissions}
                            mergeSelectionModal={{
                                data: this.props.merge_selection_modal,
                                open: this.props.onOpenMergeSelection,
                                close: this.props.onCloseMergeSelection,
                                submit: this.props.onSubmitMergeSelection,
                            }}
                        />}
                </section>
                {this.props.merge_modal_show &&<section>
                        <MergeScreen
                            patternSelected={this.patternSelectedHandler}
                            gameSelected={this.gameSelectedHandler}
                            token={this.props.token}
                            userId={this.props.userId}
                        />
                </section>}
                {!this.props.merge_modal_show && <section>
                    <Modal show={this.props.new_pattern_open} modalClosed={this.newPatternCloseHandler}>
                        <NewPattern
                            selectedPatternId={this.props.selectedPattern.id}
                            patternSelected={this.patternSelectedHandler}
                            addPattern={this.patternAddHandler}
                            cancelAddPattern={this.newPatternCloseHandler}
                            newPatternOpen={this.props.new_pattern_open}
                            updatePage={this.updatePageHandler}
                            closePatternDetails={this.patternCloseHandler}
                            userId={this.props.userId}
                            isAuthenticated={this.props.isAuthenticated}
                            authenticationLevel={this.props.authenticationLevel}
                            token={this.props.token}
                            modal={this.newPatternModal}
                            setModalText={this.newPatternModalChangeTextHandler}
                            setModalOnClose={this.newPatternModalOnCloseSet}
                            mergeSelectionModal={{
                                data: this.props.merge_selection_modal,
                                open: this.props.onOpenMergeSelection,
                                close: this.props.onCloseMergeSelection,
                                submit: this.props.onSubmitMergeSelection,
                            }}
                            permissions={this.props.permissions}
                        />
                    </Modal>

                </section>}
                <section>
                    <div className={classes.dragon}><img src={apiUrl +"Images/Dragon-rotated.png"} width="200px" alt="Pattern Dragon"/></div>
                </section>
                <PresetModal ref={this.newPatternModal} body={this.state.newPatternModalText.body}
                             title={this.state.newPatternModalText.title} onClose={this.state.newPatternModalText.onClose}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedPattern: {
            id: state.patternLibrary.selectedPattern.id
        },
        patternList: {
            offset: state.patternLibrary.patternList.offset,
            quantity: state.patternLibrary.patternList.quantity
        },
        reloadList: state.patternLibrary.reloadList,
        keywords_filter: state.patternLibrary.keywords_filter,
        conditions_filter: state.patternLibrary.conditions_filter,
        constraints_filter: state.patternLibrary.constraints_filter,
        consequences_filter: state.patternLibrary.consequences_filter,
        authors_filter: state.patternLibrary.authors_filter,
        groups_filter: state.patternLibrary.groups_filter,
        pattern_name_filter: state.patternLibrary.pattern_name_filter,
        description_filter: state.patternLibrary.description_filter,
        example_games_filter: state.patternLibrary.example_games_filter,
        design_problem_filter: state.patternLibrary.design_problem_filter,
        order_by: state.patternLibrary.order_by,
        new_pattern_open: state.patternLibrary.new_pattern_open,
        patternDetailsOpen: state.patternLibrary.patternDetailsOpen,
        patterns: state.patternLibrary.patterns,
        search_panel_active: state.patternLibrary.search_panel_active,
        isAuthenticated: state.auth.token !== null,
        userId: state.auth.userId,
        authenticationLevel: state.auth.authLevel,
        token: state.auth.token,
        permissions: state.auth.userPermissions,
        merge_selection_modal: state.modal.merge_selection_modal,
        merge_modal_show: state.modal.merge_modal.isOpen,
    }
};


const mapDispatchToProps = dispatch => {
    return {
        onSelectPattern: (selectedPatternId) => dispatch({ type: actionTypes.SELECT_PATTERN, selectedPatternId: selectedPatternId}),
        onSelectGame: (selectedGameId) => dispatch({ type: actionTypes.SELECT_GAME, selectedGameId: selectedGameId}),
        onAddPattern: () => dispatch({ type: actionTypes.ADD_PATTERN}),
        onEditPattern: () => dispatch({ type: actionTypes.EDIT_PATTERN}),
        onVotePattern: () => dispatch({ type: actionTypes.VOTE_PATTERN}),
        onNewPatternOpen: (selectedPatternId) => dispatch({ type: actionTypes.NEW_PATTERN_OPEN, selectedPatternId: selectedPatternId}),
        onNewPatternClosed: () => dispatch({ type: actionTypes.NEW_PATTERN_CLOSED}),
        onClosePatternDetails: (selectedPatternId) => dispatch({ type: actionTypes.CLOSE_PATTERN_DETAILS, selectedPatternId: selectedPatternId}),
        onUpdateKeywordsFilter: (keyword_ids) => dispatch({ type: actionTypes.UPDATE_KEYWORDS_FILTER, keywords_filter: keyword_ids}),
        onUpdateConditionsFilter: (condition_ids) => dispatch({ type: actionTypes.UPDATE_CONDITIONS_FILTER, conditions_filter: condition_ids}),
        onUpdateConstraintsFilter: (constraint_ids) => dispatch({ type: actionTypes.UPDATE_CONSTRAINTS_FILTER, constraints_filter: constraint_ids}),
        onUpdateConsequencesFilter: (consequence_ids) => dispatch({ type: actionTypes.UPDATE_CONSEQUENCES_FILTER, consequences_filter: consequence_ids}),
        onUpdateAuthorsFilter: (author_ids) => dispatch({ type: actionTypes.UPDATE_AUTHORS_FILTER, authors_filter: author_ids}),
        onUpdateGroupsFilter: (group_ids) => dispatch({ type: actionTypes.UPDATE_GROUPS_FILTER, groups_filter: group_ids}),
        onUpdatePatternNameFilter: (pattern_name_filter) => dispatch({type: actionTypes.UPDATE_PATTERN_NAME_FILTER, pattern_name_filter: pattern_name_filter}),
        onUpdateExampleGamesFilter: (game_filter) => dispatch({ type: actionTypes.UPDATE_EXAMPLE_GAMES_FILTER, example_games_filter: game_filter}),
        onUpdateDescriptionFilter: (desc_filter) => dispatch({ type: actionTypes.UPDATE_DESCRIPTION_FILTER, description_filter: desc_filter}),
        onUpdateDesignProblemFilter: (design_problem_filter) => dispatch({ type: actionTypes.UPDATE_DESIGN_PROBLEM_FILTER, design_problem_filter: design_problem_filter}),
        onUpdatePagination: (offset) => dispatch({ type: actionTypes.UPDATE_PAGINATION, offset: offset}),
        onUpdateOrderBy: (order_by) => dispatch({ type: actionTypes.UPDATE_ORDER_BY, order_by: order_by}),
        onListReloaded: () => dispatch({ type: actionTypes.LIST_RELOADED}),
        onToggleSearch: () => dispatch({ type: actionTypes.SEARCH_TOGGLE}),
        // merge modal functions
        onOpenMergeSelection: (to = null, from = null) => dispatch({ type: actionTypes.OPEN_MERGE_SELECT_MODAL, to: to, from: from}),
        onCloseMergeSelection: () => dispatch({ type: actionTypes.CLOSE_MERGE_SELECT_MODAL}),
        onSubmitMergeSelection: (to, from) => dispatch({ type: actionTypes.SUBMIT_MERGE_SELECT_MODAL, to: to, from: from}) // can't be null
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternLibrary);